import { BaseEventProps } from "../../types";

export type EventProps = BaseEventProps;

export enum MediatorEventType {
  LOGIN_WALL = "HEADER_LOGIN_WALL",
  PILL_CLICKED = "HEADER_PILL_CLICKED",
  ADD_FUNDS_CLICKED = "ADD_FUNDS_CLICKED"
}

export interface PillClickedData {
  type: MediatorEventType.PILL_CLICKED;
  payload: {
    eventLabel: string;
  };
}
export interface AddFundsData {
  type: MediatorEventType.ADD_FUNDS_CLICKED;
  payload: {
    eventPrefix: string;
  };
}
